import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Button,
  Divider,
  Icon,
  LinearProgress,
  styled,
  Typography,
} from "@mui/material";
import "./tasks.scss";
import upcomingTask from "../../assests/images/upcoming-task.svg";
import activeImg from "../../assests/images/active-img.svg";
import verifyImg from "../../assests/images/verify.svg";
import clock from "../../assests/images/clock.svg";
import coins from "../../assests/images/coins.svg";

import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { getTaskList } from "../../utils/apis";
import { AuthContext } from "../../context/AuthContext";
import Icons from "../Icons";
// import { happycoin } from "../../utils/icons";
// import { useTranslation } from "react-i18next";
// import i18n from "../../i18n";
import StepperGreen from "../stepper/Stepper";
import { useLocationStore } from "../../pages/locationStore";
import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";
import Rupees from "../../assests/images/rupeesIcon.svg";
import topIcon from "../../assests/images/topIconTask.svg";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
const StyledTabs = styled(Tab)(({ theme }) => ({
  fontSize: "12px",
  lineHeight: "20px",
  fontWeight: 500,
  textTransform: "capitalize",
  "&.Mui-selected": {
    fontWeight: "700 !important",
  },
}));
const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "capitalize",
  backgroundColor: "#C8172F",
  borderRadius: "8px",
  padding: "0px 12px 0px 12px",
  "&.Mui-disabled": {
    backgroundColor: "#7D7E7F",
    color: "#C5C6C7",
    cursor: "not-allowed",
    opacity: 0.6,
  },
}));

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


// const resolveMediaUrl = (path?: string) => {
//   if (!path) return "";

//   // already full URL → use as is
//   if (/^(https?:)?\/\//i.test(path)) return path;

//   // otherwise prepend S3 base URL
//   return `${process.env.REACT_APP_S3_STATIC_URL}${path}`;
// };

const resolveMediaUrl = (path?: string) => {
  if (!path) return "";

  const cleanPath = String(path).trim();

  // ✅ If already full URL → return directly
  if (/^(https?:)?\/\//i.test(cleanPath)) {
    return encodeURI(cleanPath);
  }

  // ✅ If relative path → add S3 base URL
  const normalizedPath = cleanPath.replace(/^\/+/, "");

  return encodeURI(
    `${process.env.REACT_APP_S3_STATIC_URL}${normalizedPath}`
  );
};


export default function Task() {
  function translate(obj: any, path: string) {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  }

  // ✅ Choose translation based on saved language
  const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";

  const translations = lang.startsWith("hi") ? translation_hi : translation_en;

  // ✅ Define t() function that mimics react-i18next’s syntax
  const t = (key: string, vars?: Record<string, any>): string => {
    let text = translate(translations, key) || key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        text = text.replace(`{{${k}}}`, String(v));
      });
    }
    return text;
  };

  // const [isLoading, setIsLoading] = useState(false);
  const [location, setLocation] = useState<{
    latitude: number | null;
    longitude: number | null;
  }>({ latitude: null, longitude: null });
  // const [error, setError] = useState<null | string>(null);
  useEffect(() => {
    localStorage.setItem("page_name", "https://in.pmiandu.com/s/pmi-all-tasks");
    console.log("✅ page_name saved to localStorage");
  }, []);

  // const [isLoading, setIsLoading] = useState(false);
  // const [location, setLocation] = useState<{ latitude: number | null; longitude: number | null }>({ latitude: null, longitude: null });
  const [error, setError] = useState<null | string>(null);
  useEffect(() => {
    localStorage.setItem("page_name", "https://in.pmiandu.com/s/pmi-all-tasks");
    console.log("✅ page_name saved to localStorage");
  }, []); 

  
  const { latitude, longitude, setLatitude, setLongitude } = useLocationStore();
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const [taskList, setTaskList] = useState({
    completed_tasks: [],
    active_tasks: [],
    upcoming_tasks: [],
  });
  const authContext = useContext(AuthContext);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // In Task component
  useEffect(() => {
    const messageListener = (event: any) => {
      console.log("Task messageListener triggered", event);
      const data = event.data;
      if (data?.data?.latitude && data?.data?.longitude) {
        console.log(
          "Task geolocation received:",
          data.data.latitude,
          data.data.longitude
        );
        setLatitude(data.data.latitude);
        setLongitude(data.data.longitude);
      }
    };

    window.addEventListener("message", messageListener);
    return () => {
      console.log("Task component unmounted, removing message listener");
      window.removeEventListener("message", messageListener);
    };
  }, [setLatitude, setLongitude]);

  console.log(latitude, longitude, "ddddwwwwwwwwwwwwwwwwww");
  useEffect(() => {
    const fetchData = async () => {
      if (authContext) {
        // const { token }: any = authContext;
        const gettoken = localStorage.getItem("token");
        try {
          const data = await getTaskList(String(gettoken));
          if (data && typeof data === "object") {
            setTaskList({
              completed_tasks: data.completed_tasks.tasks || [],
              active_tasks: data.active_tasks.tasks || [],
              upcoming_tasks: data.underreview_tasks.tasks || [],
            });
          } else {
            console.error("Data format is incorrect:", data);
          }
        } catch (error) {
          console.error("Failed to fetch data:", error);
        }
      }
    };
    fetchData();
  }, [authContext]);

  console.log("taskList", taskList);
  console.log("langauge", lang);
  const getdynmicurl = async (task_id: any, publish_id: any) => {
    const formdata = new FormData();

    const requestOptions: any = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    return await fetch(
      "https://api.mitrapp2.com/wsa/api/auth/generate-token?secret_key=s3cr3tK3y",
      requestOptions
    )
      .then((response) => response.json())
      .then((result: any) => {
        console.log(result, result.auth_token, "result token");
        console.log("langauge1", lang);
        if (result) {
          const url = `https://mitrapp2.com/wsa/app?languageId=${
            lang.startsWith("hi") ? 2 : 1
          }&token=${result.auth_token}&published_id=${publish_id}`;
          // alert(url)
          return url;
        } else {
          throw new Error("Failed to open task");
        }
        throw new Error("Failed to open task");
      })
      .catch((error) => {
        console.error(error);
        throw new Error("Failed to open task");
      });
  };
  const handleClick = async (task: any) => {
    // setIsLoading(true);

    try {
      if (task.task_type === t(`taskdetaitls.dot_code_scanning.type`)) {
        // const dynamicUrl: any = await getdynmicurl(task.task_id, task.id);
        // alert(dynamicUrl)
        navigate(`/tasks/${window.btoa(task.task_id)}`);

        // window.parent.postMessage({ action: 'redirectToDotCode', label:  dynamicUrl}, '*');
        // window.open(dynamicUrl, '_blank'); // Open in a new tab
      } else {
        navigate(`/tasks/${window.btoa(task.task_id)}`);
      }
    } finally {
      // setIsLoading(false);
    }
  };
  // const renderTask = (task: any, task_type: string) => {
  //   const getTimeLeft = (endDate: any, current_date: any) => {
  //     const end = new Date(endDate);
  //     const today = new Date(current_date);
  //     const timeDiff = end.getTime() - today.getTime();

  //     const daysLeft = Math.floor(timeDiff / (1000 * 3600 * 24));
  //     const hoursLeft = Math.floor((timeDiff % (1000 * 3600 * 24)) / (1000 * 3600));

  //     if (daysLeft > 0) {
  //       return `${daysLeft} ${daysLeft > 1 ? t('days_lefts') : t('day_left')}`;
  //     } else if (hoursLeft > 0) {
  //       return `${hoursLeft} ${hoursLeft > 1 ? t('hours_left') : t('hour_left')}`;
  //     } else {
  //       return t('task_names.expired');
  //     }
  //   }

  //   return (
  //     <Box
  //       key={task.task_id}
  //       sx={{
  //         borderRadius: "16px",
  //         background: "#FFF",
  //         padding: "12px",
  //         gap: "12px",
  //         marginBottom: "16px",
  //         textAlign: "left",
  //       }}
  //     >
  //       <Box
  //         sx={{
  //           display: "flex",
  //           justifyContent: "space-between",
  //           alignItems: "center",
  //           width: "100%",
  //         }}
  //       >
  //         <Box sx={{ display: "flex", gap: "12px", width: "250px" }}>
  //           <Box
  //             sx={{
  //               borderRadius: "9.6px",
  //               background: "rgba(255, 235, 239, 0.50)",
  //               width: "100%",
  //               maxWidth: "48px",
  //               height: "48px",
  //               padding: "8px",
  //               display: 'flex',
  //               justifyContent: 'center',
  //               alignItems: 'center',
  //             }}
  //           >
  //             {task_type === 'completed_tasks' ? <img src={verifyImg} alt="" /> : (<img src={`${process.env.REACT_APP_S3_STATIC_URL}${task.task_icon}`} alt="" />)
  //               // task.task_type === t("taskdetaitls.availability.type") ?
  //               //   <Icons name="availability" /> :
  //               //   <Icons name="educational" />
  //             }

  //           </Box>
  //           <Box>
  //             {task_type === 'active_tasks' && <Typography
  //               variant="caption1"
  //               sx={{ display: "block", color: "#696A6B" }}
  //             >
  //               {/* Task */}
  //               {t(`task`)}
  //             </Typography>}
  //             <Typography
  //               variant="caption1"
  //               sx={{ color: "#282829", fontWeight: "600" }}
  //             >
  //               {/* {task.bonus_point>0?task.task_title:task.task} */}
  //               {task.task_title}
  //             </Typography>
  //             {/* {task_type === 'upcoming_tasks' && <Typography
  //               variant="caption1"
  //               sx={{ display: "block", color: "#696A6B" }}
  //             >
  //               You will earn some Points
  //             </Typography>} */}
  //             {task_type === 'completed_tasks' && (task?.credit_points || 0 > 0) &&
  //               <Typography
  //                 variant="caption1Medium"
  //                 sx={{ display: "flex", color: "#494A4B" }}
  //               >
  //                 <Icons style={{ marginRight: '4px' }} name={task.credit_points > 0 ? "happyCoin" : "sadcoin"} />{" "}
  //                 {`${task.credit_points} ${t(`earn_pnts.points_cridited`)}`}
  //               </Typography>}
  //           </Box>
  //         </Box>
  //         {task_type === "active_tasks" && <Box
  //           sx={{
  //             borderRadius: "20px",
  //             background: "#F5F6F7",
  //             display: "flex",
  //             padding: "2px 10px",
  //             gap: "2px",
  //             whiteSpace: "nowrap",
  //           }}
  //         >
  //           <img src={clock} alt="" />
  //           <Typography
  //             variant="caption1"
  //             sx={{ display: "block", color: "#282829", fontWeight: "600" }}
  //           >
  //             {getTimeLeft(task.task_end_date, task.current_time)}
  //           </Typography>
  //         </Box>}
  //       </Box>
  //       {task.approval_status === "rejected" ? <Typography sx={{ marginTop: "10px", marginLeft: "58px", display: "inline-block", fontSize: "12px", lineHeight: "14px", color: "#DD7A00", background: "#FEF1ED", padding: "6px 10px", border: "1px solid #DD7A00", borderRadius: "40px", fontWeight: "700" }}>
  //         Rejected
  //       </Typography> : null}

  //       {task_type !== "completed_tasks" &&
  //         <>
  //           <Divider variant="fullWidth" sx={{ borderBottomStyle: "dashed", paddingBottom: "12px", marginBottom: "12px" }} />
  //           {(task.task_type === t(`taskdetaitls.dot_code_scanning.type`)) && <StepperGreen totalSteps={task.totalquestions} completedSteps={task.questionsAnswered} showPoints={task.points_earned} />}
  //           {/* <StepperGreen totalSteps={12} completedSteps={2} showPoints={20} /> */}
  //           <Box
  //             sx={{
  //               display: "flex",
  //               justifyContent: task?.credit_points || 0 > 0 ? "space-between" : "end",
  //               alignItems: "center",
  //             }}
  //           >
  //             {(task?.credit_points || 0 > 0) && <Box sx={{ display: "flex", gap: "6px" }}>
  //               <Box
  //                 sx={{
  //                   display: "flex",
  //                   width: "24px",
  //                   height: "24px",
  //                   padding: "3px 6px",
  //                   justifyContent: "center",
  //                   alignItems: "center",
  //                   gap: "3px",
  //                   borderRadius: "30px",
  //                   border: "0.75px solid #FFF2CA",
  //                 }}
  //               >
  //                 <Icons name={'happyCoin'} />
  //               </Box>
  //               <Typography
  //                 variant="caption1"
  //                 sx={{
  //                   color: "#282829",
  //                   fontWeight: "600",
  //                   alignSelf: "center",
  //                 }}
  //               >
  //                 {/* Earn {task.credit_points || 0} pts */}
  //           {task.bonus_point > 0
  // ? t("earn_pnts.points_earned_diwali", {
  //     points: task.credit_points || 0,
  //     bonus: task.bonus_point || 0,
  //   })
  // : t("earn_pnts.points_earned", {
  //     points: task.credit_points || 0,
  //   })}
  //                 {/* {task.bonus_point > 0 ?t("earn_pnts.points_earned_diwali"):t("diwali_points.points_earned")} */}
  //                 {/* {task.bonus_point > 0 ? `${t('earn_pnts.points_earned_diwali', { points: task.credit_points || 0, bonus: task.bonus_point || 0 })}` : `${t('earn_pnts.points_earned', { points: task.credit_points || 0 })}`} */}
  //                 {/* {task.credit_points || 0}{" "}{t(`earn_pnts.points_earned`} */}
  //                 {/* {`${t("diwali_points.points_earned")}`}: {task.credit_points} */}
  //                 {/* {task.bonus_point > 0 && (
  //                 <> + {task.bonus_point} pts </>
  //               )} */}
  //               </Typography>
  //             </Box>}
  //             <StyledButton
  //               disabled={task_type === "upcoming_tasks" || getTimeLeft(task.task_end_date, task.current_time)?.trim() === t(`task_names.expired`)}
  //               onClick={() => {
  //                 console.log('Button clicked', { task });
  //                 window.parent.postMessage(
  //                   { action: 'redirectToTaskPage', label: task.task_id },
  //                   '*'
  //                 );
  //               }}

  //               sx={{
  //                 fontSize: "14px",
  //                 fontWeight: "500",
  //                 lineHeight: "21px",
  //                 color: "#fff !important",
  //                 display: "flex",
  //                 height: "32px",
  //                 padding: "0px 12px",
  //                 alignItems: "center",
  //                 borderRadius: "8px",
  //                 background: "#C8172F",
  //                 width: "auto !Important",
  //               }}
  //             >

  //               {task_type === "upcoming_tasks" ? t("task_names.restart_the_task") : task.approval_status === "rejected" ? t("task_names.restart_the_task") : task.questionsAnswered > 0 ? t("task_names.resume_task") : t("task_names.start_the_task")}

  //             </StyledButton>
  //           </Box>
  //         </>
  //       }
  //     </Box>
  //   );
  // };
  const renderTask = (task: any, task_type: string) => {
    // normalize multiscan flag (handle backend typo variants)
    const isMultiscan =
      Number(task?.is_mutliscan || task?.is_multiscan || 0) === 1;

    const getTimeLeft = (endDate: any, current_date: any) => {
      const end = new Date(endDate);
      const today = new Date(current_date);
      const timeDiff = end.getTime() - today.getTime();

      const daysLeft = Math.floor(timeDiff / (1000 * 3600 * 24));
      const hoursLeft = Math.floor(
        (timeDiff % (1000 * 3600 * 24)) / (1000 * 3600)
      );

      if (daysLeft > 0) {
        return `${daysLeft} ${daysLeft > 1 ? t("days_lefts") : t("day_left")}`;
      } else if (hoursLeft > 0) {
        return `${hoursLeft} ${
          hoursLeft > 1 ? t("hours_left") : t("hour_left")
        }`;
      } else {
        return t("task_names.expired");
      }
    };
const isTopTask =
  task.task_type === "TOP" || task.task_type === "टॉप";

// helper
const parsePoints = (value: any) => {
  if (typeof value === "string") {
    return Number(value.replace(/[₹,]/g, "").trim()) || 0;
  }
  return Number(value) || 0;
};

// ✅ MAGIC FIX
const creditPoints = isTopTask
  ? Object.assign(parsePoints(task?.credit_points), {
      toString: () => task?.credit_points, // <-- shows ₹500
    })
  : parsePoints(task?.credit_points);

const bonusPoints = parsePoints(task?.bonus_point);

const earnPoints = isTopTask
  ? Object.assign(parsePoints(task?.points_earned), {
      toString: () => task?.points_earned, // <-- shows ₹30
    })
  : parsePoints(task?.points_earned);
    return (
      <Box    
        key={task.task_id}
        sx={{
          borderRadius: "16px",
          background: "#FFF",
          padding: "12px",
          gap: "12px",
          marginBottom: "16px",
          textAlign: "left",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", gap: "12px", width: "250px", alignItems: "center" }}>
            <Box
              sx={{
                borderRadius: "9.6px",
                background: "rgba(255, 235, 239, 0.50)",
                width: "100%",
                maxWidth: "48px",
                height: "48px",
                padding: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {/* {task_type === "completed_tasks" ? (
                <img src={verifyImg} alt="" />
              ) : (
                <img
                  src={resolveMediaUrl(task.task_icon)}
                  alt=""
                />
              )} */}

       {task_type === "completed_tasks" ? (
  <img src={verifyImg} alt="completed" />
) : isTopTask ? (
  <img src={topIcon} alt="rupees icon" style={{ width: "24px" }} />
) : (
  <img
    src={resolveMediaUrl(task?.task_icon)}
    alt="task icon"
    onError={(e: any) => {
      e.currentTarget.src =
        "https://llp-pmi-prod-assets.s3.ap-south-1.amazonaws.com/assets/icon1.svg";
    }}
  />
)}
            </Box>

            <Box>
              {task_type === "active_tasks" && (
                <Typography
                  variant="caption1"
                  sx={{ display: "block", color: "#696A6B" }}
                >
                  {t(`task`)}
                </Typography>
              )}

              <Typography
                variant="caption1"
                sx={{ color: "#282829", fontWeight: "600" }}
              >
                {task.task_title}
              </Typography>

              {/* {task_type === "completed_tasks" && creditPoints > 0 && (
                <><Typography
                  variant="caption1Medium"
                  sx={{ display: "flex", color: "#494A4B" }}
                >
                  <Icons
                    style={{ marginRight: "4px" }}
                    name={creditPoints > 0 ? "happyCoin" : "sadcoin"} />{" "}
                  {`${creditPoints} ${t(`earn_pnts.points_cridited`)}`}
                </Typography>
                  </>
              )} */}
               {/* {task_type === "completed_tasks" && earnPoints > 0 && ( */}
 {task_type === "completed_tasks"  && (
                
                <Box sx={{display:"flex"}}>
                  <Icons
                    style={{ marginRight: "4px" }}
                    name={earnPoints > 0 ? "happyCoin" : "sadcoin"} />  
                    <Typography sx={{marginRight:"5px", fontSize:"12px",}}>
                       {isTopTask
                          ? t("earn_pnts.rupee_credited", { amount: earnPoints })
                          : `${earnPoints} ${t("earn_pnts.points_cridited")}`}
                       </Typography>
                     </Box>
                
              )}

                   {task_type === "completed_tasks" && (
  <Box>
    <Typography sx={{ fontSize: "12px", color: "#696A6B", whiteSpace: "nowrap" }}>
       {`${t(`earn_pnts.credited_on`)}`} : {task?.completed_at}
    </Typography>
  </Box>
)}
              {/* <Box>
              <Typography sx={{fontSize:"12px", color:"#696A6B"}}>Credited on: {task?.completed_at}</Typography>
            </Box> */}
            </Box>
           
          </Box>

          {task_type === "active_tasks" && (
            <Box
              sx={{
                borderRadius: "20px",
                background: "#F5F6F7",
                display: "flex",
                padding: "2px 10px",
                gap: "2px",
                whiteSpace: "nowrap",
              }}
            >
              <img src={clock} alt="" />
              <Typography
                variant="caption1"
                sx={{ display: "block", color: "#282829", fontWeight: "600" }}
              >
                {getTimeLeft(task.task_end_date, task.current_time)}
              </Typography>
            </Box>
          )}

    

{task_type === "upcoming_tasks" && (
            <Box
              sx={{
                borderRadius: "20px",
                // background: "#F5F6F7",
                display: "flex",
                padding: "2px 10px",
                gap: "2px",
                whiteSpace: "nowrap",
              }}
            >
             <Icons name={"happyCoin"} />
              
            </Box>
          )}
        </Box>

        {task.approval_status === "rejected" ? (
          <Typography
            sx={{
              marginTop: "10px",
              marginLeft: "58px",
              display: "inline-block",
              fontSize: "12px",
              lineHeight: "14px",
              color: "#DD7A00",
              background: "#FEF1ED",
              padding: "6px 10px",
              border: "1px solid #DD7A00",
              borderRadius: "40px",
              fontWeight: "700",
            }}
          >
            Rejected
          </Typography>
        ) : null}

        {task_type !== "completed_tasks" && (
          <>
            <Divider
              variant="fullWidth"
              sx={{
                borderBottomStyle: "dashed",
                paddingBottom: "12px",
                marginBottom: "12px",
              }}
            />

            {/* For multiscan tasks: Show progress bar instead of StepperGreen */}
            {isMultiscan && (
              <Box mt={1.5}>
                {(() => {
                  const earned = Number(task.points_earned || 0);
                  const target = Number(task.credit_points || 0);
                  const percent = target ? (earned / target) * 100 : 0;

                  // let progressColor = "#C8172F";
                  // if (percent > 0 && percent < 100) progressColor = "#FF933A ";
                  // if (percent >= 100) progressColor = "#4CAF50";
                  const progressColor = "#4CAF50";
                  return (
                    <LinearProgress
                      variant="determinate"
                      value={percent > 100 ? 100 : percent}
                      sx={{
                        height: 4,

                        borderRadius: 5,
                        backgroundColor: "#E0E0E0",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: progressColor,
                        },
                      }}
                    />
                  );
                })()}
              </Box>
            )}

            {/* For regular tasks: Show StepperGreen as before */}
            {!isMultiscan &&
              task.task_type === t(`taskdetaitls.dot_code_scanning.type`) && (
                <StepperGreen
                  totalSteps={Number(task?.totalquestions) || 0}
                  completedSteps={Number(task?.questionsAnswered) || 0}
                  showPoints={Number(task?.points_earned || 0)}
                />
              )}

            {/* Bottom row: keep button and (if not multiscan) points area */}
            <Box
              sx={{
                display: "flex",
                justifyContent: creditPoints > 0 ? "space-between" : "end",
                alignItems: "center",
              }}
            >
              {creditPoints > 0 && (
                <Box sx={{ display: "flex", gap: "6px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      width: "24px",
                      height: "24px",
                      padding: "3px 6px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "3px",
                      borderRadius: "30px",
                      border: "0.75px solid #FFF2CA",
                    }}
                  >
                    {isTopTask ? (
   <img src={Rupees} alt="scan Icon" style={{width:"22px"}} />
  ) : (
    <Icons name={"happyCoin"} />
  )}
                  </Box>
                  <Typography
                    variant="caption1"
                    sx={{
                      color: "#282829",
                      fontWeight: "600",
                      alignSelf: "center",
                    }}
                  >
                    {/* For multiscan: show points format, for regular: show translated text */}
                    {isMultiscan
                      ? `${task.points_earned || 0}/${creditPoints}`
                      : isTopTask
                      ? t("earn_pnts.points_earned_top", { points: creditPoints })
                      : bonusPoints > 0
                      ? t("earn_pnts.points_earned_diwali", {
                          points: creditPoints,
                          bonus: bonusPoints,
                        })
                      : t("earn_pnts.points_earned", { points: creditPoints })}
                  </Typography>
                </Box>
              )}

              {/* <StyledButton
                disabled={
                  task_type === "upcoming_tasks" ||
                  getTimeLeft(task.task_end_date, task.current_time)?.trim() ===
                    t(`task_names.expired`)
                }
                onClick={() => {
                  if (isTopTask) {
                    navigate('/top');
                  } else {
                    console.log("Button clicked", { task });
                    window.parent.postMessage(
                      { action: "redirectToTaskPage", label: task.task_id },
                      "*"
                    );
                  }
                }}
                sx={{
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "21px",
                  color: "#fff !important",
                  display: "flex",
                  height: "32px",
                  padding: "0px 12px",
                  alignItems: "center",
                  borderRadius: "8px",
                  background: "#C8172F",
                  width: "auto !Important",
                }}
              >
                {task_type === "upcoming_tasks"
                  ? t("task_names.in_review")
                  : task.approval_status === "rejected"
                  ? t("task_names.restart_the_task")
                  : task.questionsAnswered > 0
                  ? t("task_names.resume_task")
                  : t("task_names.start_the_task")}
              </StyledButton> */}
         

<StyledButton
  disabled={
    !isTopTask &&
    (
      task_type === "upcoming_tasks" ||
      getTimeLeft(task.task_end_date, task.current_time)?.trim() ===
        t(`task_names.expired`)
    )
  }
  onClick={() => {
    if (isTopTask) {
      navigate("/top");
    } else {
      console.log("Button clicked", { task });

      window.parent.postMessage(
        {
          action: "redirectToTaskPage",
          label: task.task_id,
        },
        "*"
      );
    }
  }}
  sx={{
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "21px",
    color: "#fff !important",
    display: "flex",
    height: "32px",
    padding: "0px 12px",
    alignItems: "center",
    borderRadius: "8px",
    background: "#C8172F",
    width: "auto !Important",
  }}
>
   {task_type === "upcoming_tasks"
    ? t("task_names.in_review")
    : isTopTask && task_type === "upcoming_tasks"
    ? "In Progress"
    : task.approval_status === "rejected"
    ? t("task_names.restart_the_task")
    : task.questionsAnswered > 0
    ? t("task_names.resume_task")
    : t("task_names.start_the_task")}
</StyledButton>
            </Box>
          </>
        )}

        
      </Box>
    );
  };

  const { completed_tasks, active_tasks, upcoming_tasks } = taskList;

  return (
    <section>
      <Box sx={{ width: "100%" }} className="taskTabs">
        <Box sx={{ backgroundColor: "#FFF" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            variant="fullWidth"
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <StyledTabs
              label={`${t("tasks.active_tab")} (${active_tasks.length})`}
              {...a11yProps(0)}
            />
            <StyledTabs
              label={`${t("tasks.inreview_tab")} (${upcoming_tasks.length})`}
              {...a11yProps(1)}
            />
            <StyledTabs
              label={`${t("tasks.completed_tab")} (${completed_tasks.length})`}
              {...a11yProps(2)}
            />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          {active_tasks.map((task: any) => renderTask(task, "active_tasks"))}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          {upcoming_tasks.map((task: any) =>
            renderTask(task, "upcoming_tasks")
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {completed_tasks.map((task: any) =>
            renderTask(task, "completed_tasks")
          )}
        </CustomTabPanel>
      </Box>
    </section>
  );
}